import { css } from '@emotion/react';
import { Button } from 'components/Button';
import { Tooltip, TooltipDirection } from 'components/Tooltip';
import { IconEdit } from 'icons/icon-edit';
import { IconExport } from 'icons/icon-export';
import React from 'react';
import { LISTING_TYPE } from '../ScreenRequest';
import { IconState } from 'components/ProcessStep';
import { theme } from 'styles/theme';
import { format } from 'date-fns';
import { FEE_TYPE } from 'screens/booking/steps/FeeStep';
import { Badge } from 'components/Badge';
import { FlexStyle } from 'styles/FlexStyles';
import { getFormattedPrice } from 'utils/utils';
import { SizeStyle } from 'styles/SizeStyle';
import { ButtonLink } from 'components/ButtonLink';
import { IconContract } from 'icons/icon-contract';
import { IconInvoice } from 'icons/icon-invoice';
import { CopyToClipboard } from './CopyToClipboard';
import { IconCopy } from 'icons/icon-copy';
import { IconExternal } from 'icons/icon-external';
import { routes } from 'routes';
import { ListingItemStyle } from '../../artists/ScreenArtists';
import { useEventDays } from 'screens/booking/hooks/useEventDays';
import slugify from '@sindresorhus/slugify';

export const RequestItem = ({
	id,
	// url,
	event_name,
	event_date,

	fee_type,
	// fee_amount,
	fee_total,
	fee_vat,
	fee_other,

	event_address_city,
	event_address_place,
	artist,
	confirmed,
	// steps_done,
	isCompleted,
	link_invoice,
	link_contract,
	time_performance,
	exported_at,
	notified_at,

	listingType,

	open,
	setDetailRequestUrl,

	setExportRequestUrl,
	exportOpen,

	setNotifyRequestUrl,
	notifyOpen,
}: {
	id: string;
	// url: string;
	event_name: string;
	event_date: Date;

	fee_type: FEE_TYPE;
	// fee_amount: number;
	fee_total: number;
	fee_vat: boolean;
	fee_other: string;

	artist: any;

	event_address_city: string;
	event_address_place: string;

	confirmed: boolean;
	// steps_done: number;
	isCompleted: boolean;

	link_invoice: string;
	link_contract: string;

	time_performance: string;

	exported_at: Date;
	notified_at: Date;

	listingType: LISTING_TYPE;

	open: () => void;
	exportOpen: () => void;
	notifyOpen: () => void;

	setDetailRequestUrl: (id: string) => void;
	setExportRequestUrl: (id: string) => void;
	setNotifyRequestUrl: (id: string) => void;
}) => {
	// const today = new Date();
	// const eventDate = new Date(event_date);
	// const restDays = differenceInDays(eventDate, today);
	// const isUrgent = !isCompleted && restDays <= 14;

	const { restDays, restDaysString, isUrgent } = useEventDays({
		event_date: event_date,
		isCompleted: isCompleted,
	});

	console.log(restDays, event_date, event_name);

	return (
		<div
			key={id}
			// to={routes.booker.request + id}
			css={[
				ListingItemStyle(),
				css`
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 13px;
					line-height: 20px;

					${isUrgent &&
					css`
						border-color: ${theme.color.danger[25]};
						background: ${theme.color.danger[25]};

						&:hover {
							border-color: ${theme.color.danger[50]};
							background: ${theme.color.danger[50]};
						}
					`}
				`,
			]}
			onClick={() => {
				setDetailRequestUrl(id);
				open();
			}}
		>
			<div
				css={css`
					display: flex;
					align-items: center;
				`}
			>
				<div
					css={[
						FlexStyle(),
						css`
							gap: 16px;
							align-items: center;
						`,
					]}
				>
					<div>
						<img
							src={process.env.ASSETS_URL + 'artists/' + slugify(artist?.url) + '.png'}
							css={css`
								border-radius: 16px;
								width: 40px;
								flex-shrink: 0;
								margin-bottom: 2px;
							`}
						/>

						<div>
							<Tooltip
								content={
									confirmed ? (
										<div>
											<div>
												<strong>Poptávka potvrzena</strong>
											</div>
											<div>
												{isCompleted
													? 'Všechny potřebné údaje jsou vyplněny. '
													: 'Některé údaje chybí.'}
											</div>
										</div>
									) : (
										<div>
											<div>
												<strong>Poptávka zatím nebyla potvrzena</strong>
											</div>
										</div>
									)
								}
								direction={TooltipDirection.TOP}
							>
								<IconState
									isSquared
									isDone={isCompleted && confirmed}
									isIncomplete={!isCompleted && confirmed}
									isIncompleteDanger={!isCompleted && isUrgent && confirmed}
								/>
							</Tooltip>
						</div>
					</div>

					<div>
						<strong>{artist?.name}</strong> {event_name && <> - {event_name}</>}
						<div
							css={css`
								color: ${theme.color.text['300']};
							`}
						>
							<strong>
								{event_date ? format(new Date(event_date), 'dd. MM. yyy') : event_date}
								{''} ·{' '}
								<span
									css={css`
										${isUrgent &&
										css`
											color: red;
										`}
									`}
								>
									{restDaysString}
								</span>
							</strong>
						</div>
						<div
							css={css`
								color: ${theme.color.text['300']};
							`}
						>
							{event_address_city}
							{''} · {event_address_place} · {''}
							{time_performance ? (
								<>{format(new Date('2020-01-01 ' + time_performance), 'HH:mm')}</>
							) : (
								<em
									css={css`
										color: #e69500;
									`}
								>
									Čas konání bude upřesněn
								</em>
							)}
						</div>
					</div>
				</div>
			</div>

			<div css={FlexStyle({ alignItemsCenter: true })}>
				<div
					css={css`
						${SizeStyle({ w: 200 })}
					`}
				>
					{fee_type === FEE_TYPE.FIXED && (
						<Badge success={fee_vat} primary={!fee_vat}>
							{getFormattedPrice(fee_total, fee_vat)}
						</Badge>
					)}

					{fee_type === FEE_TYPE.OTHER && (
						<div
							css={css`
								display: inline-flex;
							`}
						>
							<Tooltip content={fee_other} direction={TooltipDirection.TOP}>
								<Badge secondary>Jiné podmínky</Badge>
							</Tooltip>
						</div>
					)}
				</div>

				<div
					css={css`
						${SizeStyle({ w: 200 })}
						font-size: 12px;
						line-height: 20px;
					`}
				>
					{exported_at && (
						<div
							css={css`
								color: ${theme.color.primary[400]};
							`}
						>
							<strong>Export:</strong> {format(new Date(exported_at), 'dd. MM. yyy, HH:mm')}
						</div>
					)}
					{notified_at && (
						<div
							css={css`
								color: ${theme.color.danger[400]};
							`}
						>
							<strong>Urgence:</strong> {format(new Date(notified_at), 'dd. MM. yyy, HH:mm')}
						</div>
					)}
				</div>

				{listingType != LISTING_TYPE.PAST && (
					<Button
						small
						ghostPrimary
						onClick={(e) => {
							setNotifyRequestUrl(id);
							notifyOpen();

							e.preventDefault();
							e.stopPropagation();
						}}
					>
						Zaurgovat
					</Button>
				)}

				<div
					css={css`
						margin-left: 12px;
					`}
				>
					<Tooltip
						content={!!link_contract ? 'Otevřít smlouvu' : 'Smlouva není dostupná'}
						direction={TooltipDirection.TOP}
					>
						<ButtonLink to={link_contract} ghost small square external disabled={!link_contract}>
							<IconContract />
						</ButtonLink>
					</Tooltip>
				</div>

				<div
					css={css`
						margin-left: 4px;
					`}
				>
					<Tooltip
						content={!!link_invoice ? 'Otevřít fakturu' : 'Faktura není dostupná'}
						direction={TooltipDirection.TOP}
					>
						<ButtonLink to={link_invoice} ghost small square external disabled={!link_invoice}>
							<IconInvoice />
						</ButtonLink>
					</Tooltip>
				</div>

				{/* <div
					css={css`
						margin-left: 4px;
					`}
				>
					<Tooltip content="Otevřít v novém okně" direction={TooltipDirection.TOP}>
						<ButtonLink
							small
							ghost
							external
							square
							to={process.env.BASE_URL + 'booking/' + id + '/'}
						>
							<IconExternal />
						</ButtonLink>
					</Tooltip>
				</div>

				<div
					css={css`
						margin-left: 4px;
					`}
				>
					<CopyToClipboard ghost small value={process.env.BASE_URL + 'booking/' + id + '/'} square>
						<IconCopy />
					</CopyToClipboard>
				</div> */}

				{listingType != LISTING_TYPE.PAST && (
					<div
						css={css`
							margin-left: 4px;
						`}
					>
						<Tooltip content="Export do Google Calendar" direction={TooltipDirection.TOP}>
							<Button
								// to={routes.booker.request}
								onClick={(e) => {
									setExportRequestUrl(id);
									exportOpen();

									e.preventDefault();
									e.stopPropagation();
								}}
								ghost
								small
								square
							>
								<IconExport />
							</Button>
						</Tooltip>
					</div>
				)}

				<div
					css={css`
						margin-left: 16px;
						margin-right: 0px;
					`}
				>
					<Tooltip content="Upravit poptávku" direction={TooltipDirection.TOP}>
						<ButtonLink small ghost to={routes.booker.request + id}>
							<IconEdit />
						</ButtonLink>
					</Tooltip>
				</div>
			</div>
		</div>
	);
};
